import { apiSlice } from './apiSlice';

/**
 * Account Setup details: Platform credentials and Receipt information.
 *
 *   GET /v2/account-setup/?login_id=<login_id>&platform=<platform>
 *
 * Sample response:
 * {
 *   "login_id": "2887900",
 *   "platform": "mt5",
 *   "account_information": {
 *     "login": "2887900",
 *     "master_password": "...",
 *     "investor_password": "...",
 *     "server": "ACGMarkets-Main",
 *     "web_terminal": null
 *   },
 *   "receipt": {
 *     "available": true,
 *     "invoice": "N/A",
 *     "reason": null,
 *     "reason_text": null,
 *     "login_id": "2887900",
 *     "order_id": "3adcd9b3-e47d-488d-a5f7-8702bfaf0c41",
 *     "purchase_date": "2025-03-10T17:22:31.767841Z",
 *     "plan_type": "Alpha pro",
 *     "account_size": 5000,
 *     "challenge_name": "Alpha Pro 8% Legacy 5K",
 *     "amount": "7700",
 *     "payment_status": "succeeded"
 *   }
 * }
 */
export const accountSetupApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAccountSetup: builder.query({
      query: ({ loginId, login_id, platform } = {}) => ({
        url: '/v2/account-setup/',
        params: {
          login_id: loginId ?? login_id,
          platform,
        },
      }),
      providesTags: ['Account'],
    }),
  }),
});

export const { useGetAccountSetupQuery, useLazyGetAccountSetupQuery } = accountSetupApi;
